import type { FC } from "react";
import { memo } from "react";
import {
  Card as CardMui,
  CardActionArea,
  CardContent,
  CardMedia,
} from "@mui/material";
import type { CardProps } from "./card.types";
import { CardDescription, CardTitle, CardWrapper } from "./card.styles";

export const Card: FC<CardProps> = memo(({ image, title, description }) => {
  return (
    <CardWrapper>
      <CardMui sx={{ width: 552 }}>
        <CardActionArea>
          {image && (
            <CardMedia
              component="img"
              height="192"
              image={image}
              alt="card-image"
            />
          )}
          <CardContent>
            <CardTitle>{title}</CardTitle>
            <CardDescription>{description}</CardDescription>
          </CardContent>
        </CardActionArea>
      </CardMui>
    </CardWrapper>
  );
});
